import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'
import styled from 'styled-components'

export const ErrorMessageStyled = styled.div`
  font-weight: 500;
  font-size: 14px;
  margin-top: 5px;
  color: #ff3d71;
  position: relative;
  line-height: 20px;
`

const ErrorsList = () => {
  const { values, isValid, errors, setTouched } = useFormikContext()

  const isCaptchaFilled = !!values?.captcha
  const fieldsToTouch = {}

  Object.keys(errors).map(key => {
    fieldsToTouch[key] = true
  })

  useEffect(() => {
    if (isCaptchaFilled) {
      setTouched(fieldsToTouch, true)
    }
  }, [isCaptchaFilled])

  if (isCaptchaFilled && !isValid) {
    return (
      <ErrorMessageStyled>
        Please fill in all required fields
      </ErrorMessageStyled>
    )
  }

  return null
}

export default ErrorsList
